<template>
	<div id="app">
		<!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
		<router-view />
		<footer></footer>
	</div>
</template>
<script>

export default {
  mounted() {
    if (this._isMobile()) {
      // window.location.href ="http://m.ycszyy.zhongzhiyunda.com"
      window.location.href ="http://m.wxbm.zzydtec.com"
      // this.$confirm("为了保证提交信息的准确无误，建议您使用电脑端的360或者谷歌浏览器参加报名。通过手机端报名考试的考生，产生信息不准确等后果，由考生本人承担！", '温馨提示', {
      //   confirmButtonText: '确定',
      //   showCancelButton:false,
      //   type: 'warning'
      // }).then(()=>{
      //   this.$router.push({
      //     path: '/'
      //   })
      // })
    }
    // else {
    //   alert("pc端");
    //   // this.$router.replace('/pc_index');
    // }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  }
}
</script>
<style lang="less">
	div {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		margin: 0;
		padding: 0;
	}
	body {
		background:url(assets/dabg.png);
		background-size: cover;
		background-repeat:no-repeat;
		background-attachment:fixed;
		background-position:top;
		bottom:0px !important;
	}

@media screen and (min-width: 1000px) {
		.rebag {
			float: left;
			width: 100%;
		}
	}

	@media screen and (max-width: 1000px) {
		.rebag {
			float: left;
		}
	}
	#app {
		font-family:Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	#nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
</style>
